import { SetRoutes } from 'components';
import MainPage from './main';
import Layout from 'components/layout';

const ClickCollectPage = () => {
  return (
    <Layout>
      <SetRoutes
        routes={[
          {
            path: '/*',
            Component: MainPage,
            props: {},
          },
        ]}
      />
    </Layout>
  );
};

export default ClickCollectPage;
